/* Wave configurator: aantal + tijdelijke korting in het overzicht.
   Instellingen staan op de <script>-tag in snippets/wave-sticky-bar.liquid:
   data-pct (percentage), data-min (minimaal subtotaal in centen), data-label (tekst).
   Uitzetten: data-pct="0" of de regel met wave-cfg-promo.js weghalen. */
(function () {
  var me = document.currentScript || {};
  var ds = me.dataset || {};
  var PCT = parseFloat(ds.pct) || 0;
  var MIN = parseInt(ds.min, 10) || 0;
  var LBL = ds.label || 'Korting';

  var r = document.querySelector('[data-wvc]');
  if (!r || r.dataset.wvcPromo) return;
  r.dataset.wvcPromo = '1';
  var sum = r.querySelector('.wvc__sum');
  var tot = r.querySelector('[data-wvc-total]');
  if (!sum || !tot) return;
  var totRow = tot.closest('.wvc__sum-total');

  var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  var fmt = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: cur });
  var money = function (c) { return fmt.format(c / 100); };
  var cents = function (t) {
    var s = String(t || '').replace(/[^\d,]/g, '').replace(',', '.');
    return Math.round((parseFloat(s) || 0) * 100);
  };

  var unit = cents(tot.textContent);
  var last = null;
  var mo;

  function qty() {
    var f = document.querySelector('form.js-product-form-main');
    var q = (f && f.querySelector('[name="quantity"]')) || document.querySelector('input[name="quantity"]');
    return Math.max(1, parseInt(q && q.value, 10) || 1);
  }

  function row(left, right, cls) {
    var d = document.createElement('div');
    d.className = 'wvc__sum-row' + (cls ? ' ' + cls : '');
    d.setAttribute('data-wvc-promo', '');
    var a = document.createElement('span'); a.textContent = left;
    var b = document.createElement('span'); b.textContent = right;
    d.appendChild(a); d.appendChild(b);
    return d;
  }

  function render() {
    if (mo) mo.disconnect();
    var t = tot.textContent;
    if (t !== last) unit = cents(t); /* nieuwe stuksprijs van wave-configurator.js */
    [].slice.call(sum.querySelectorAll('[data-wvc-promo]')).forEach(function (el) { el.remove(); });

    var n = qty();
    var sub = unit * n;
    if (n > 1) {
      sum.insertBefore(row('Subtotaal ' + n + ' × ' + money(unit), money(sub)), totRow);
    }
    var disc = PCT > 0 && sub >= MIN ? Math.round(sub * PCT / 100) : 0;
    if (disc) {
      sum.insertBefore(row(LBL + ' (' + String(PCT).replace('.', ',') + '%)', '− ' + money(disc), 'wvc__sum-row--promo'), totRow);
    }
    tot.textContent = money(sub - disc);
    last = tot.textContent;
    if (mo) mo.observe(sum, { childList: true, characterData: true, subtree: true });
  }

  if (!document.getElementById('wvc-promo-css')) {
    var st = document.createElement('style');
    st.id = 'wvc-promo-css';
    st.textContent = '.wvc__sum-row--promo{color:#2f6b3a;font-weight:600}';
    document.head.appendChild(st);
  }

  try { mo = new MutationObserver(render); } catch (e) {}
  function onQty(e) { if (e.target && e.target.name === 'quantity') render(); }
  document.addEventListener('change', onQty);
  document.addEventListener('input', onQty);
  render();
})();
